<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="!persistant"
    transition="scale-transition"
    offset-y
    min-width="290px"
    >
    <template #activator="{ on }">
      <slot name="selector" :on="on">
        <div class="readonly-content"
          v-if="readonly"
          >
          <v-icon class="mr-2">today</v-icon>
          <div>{{value}}</div>
        </div>
       <v-text-field
        v-else
        class="ma-0 pa-0"
        :value="value"
        @input="$emit('input', $event)"
        :label="placeholder"
        readonly
        v-on="on"
        :clearable="no_clear?false:true"
        >
          <template slot="prepend">
            <v-icon v-on="on">event</v-icon>
          </template>
        </v-text-field>
      </slot>
    </template>
    <v-date-picker
      :value="value"
      @input="$emit('input', $event)"
      no-title scrollable
      :first-day-of-week="first_day_of_week_integer"
      :locale-first-day-of-year="4"
      :allowed-dates="allowed_dates"
      color="blue lighten-1"
      :show-current="true"
      show-week
      :multiple="multiple"
      next-icon="chevron_right"
      prev-icon="chevron_left"
      >
      <v-spacer/>
      <v-btn v-if="ok_button" @click="menu = false">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>
<script>
  export default {
    props: ['value', 'readonly', 'first_day_of_week', 'allowed_dates', 'placeholder', 'persistant',
            'multiple', 'ok_button', 'no_clear'
    ],
    data: () => ({
      menu: false,
      week_days_string: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
    }),
    computed: {
      first_day_of_week_integer: function() {
          if (this.week_days_string.includes(this.first_day_of_week)) {
            return this.week_days_string.indexOf(this.first_day_of_week)
          } else {
            return this.first_day_of_week
          }
      }
    }
  }
</script>
<style>
  .readonly-content {
    display: flex;
    height: 32px;
    align-items: center;
  }
</style>
